import React, { useEffect } from 'react'
import { render } from 'react-dom'
import getRoot from 'get-root'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from '@apollo/client'
import './index.css'
import { AuthProviderReact, getToken } from './auth'
import AuthWall from './components/App/AuthWall'
import { Provider as ReduxProvider } from 'react-redux'
import store from './store'
import { resetTandC } from './actions'
import { useDispatch } from 'react-redux'

const client = new ApolloClient({
  link: createHttpLink({
    uri: process.env.REACT_APP_API || '/graphql',
    fetch: (uri, options = {}) => {
      const headers = new Headers(options.headers || {})
      const token = getToken()
      if (token) headers.set('Authorization', `Bearer ${token}`)
      return fetch(uri, { ...options, headers })
    },
  }),
  cache: new InMemoryCache(),
})

const Root = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (!getToken()) {
      // not logged in
      dispatch(resetTandC())
    }
  }, [getToken()])
  return (
    <AuthProviderReact>
      <ApolloProvider client={client}>
        <AuthWall />
      </ApolloProvider>
    </AuthProviderReact>
  )
}

render(
  <ReduxProvider store={store}>
    <Root />
  </ReduxProvider>,
  getRoot()
)
